export const logUnavailableProduct = (
  prodName: string,
  dateRange: string,
  prodCategory: string
) => {
  if (dateRange === '' || dateRange.includes('undefined')) return;
  dataLayer.push({
    event: 'ga4Event',
    event_name: 'musaitlik_yok',
    prod_name: prodName,
    date_range: dateRange,
    prod_cat: prodCategory,
  });
};
